import { Routes, Route, Navigate } from 'react-router-dom';
import LandingScreen from '../screens/LandingScreen.jsx';
import HowToPlayScreen from '../screens/HowToPlayScreen.jsx';
import GameScreen from '../screens/GameScreen.jsx';
import NiceJobScreen from '../screens/NiceJobScreen.jsx';
import SubmittionScreen from '../screens/SubmittionScreen.jsx';
import { loadFromLocalStorage } from '../utils/storage.js';

const SnowmanRouter = () => {
  const gameSessionStarted = loadFromLocalStorage('gameSessionStarted');
  return (
    <Routes>
      <Route path='/' element={<LandingScreen />} />
      <Route path='/how-to-play' element={<HowToPlayScreen />} />
      <Route path='/nice-job' element={<NiceJobScreen />} />
      {gameSessionStarted ? (
        <Route path='/game-play' element={<Navigate to='/' replace />} />
      ) : null}
      <Route path='/game-play' element={<GameScreen />} />
      <Route path='/submittion' element={<SubmittionScreen />} />
    </Routes>
  );
};

export default SnowmanRouter;
